import { render } from "./TaskFormModal.vue?vue&type=template&id=24d50fab&scoped=true"
import script from "./TaskFormModal.vue?vue&type=script&lang=js"
export * from "./TaskFormModal.vue?vue&type=script&lang=js"

import "./TaskFormModal.vue?vue&type=style&index=0&id=24d50fab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d50fab"]])

export default __exports__